import React, { useState } from 'react'
import '../../styles/header.scss';
import {GiHamburgerMenu} from 'react-icons/gi'
import {FiShoppingCart,FiLogIn} from 'react-icons/fi'
import {FaUser} from 'react-icons/fa'
import { Link } from 'react-router-dom'
import {motion} from 'framer-motion'
const Header = ({isAuthenticated=false}) => {
    const [toggle, setToggle] = useState(false)
    const [navbar, setNavbar] = useState(false)
    console.log(navbar)
    const changeNavbar = () =>{
      if(window.scrollY >= 80){
        setNavbar(true)
      }else{
        setNavbar(false)
      }
    }
    window.addEventListener("scroll",changeNavbar)
  return <nav className={`${navbar && 'isScroll'}`}>
    <motion.div  initial={{x:"-100%"}} whileInView={{x:0}}>
        <img src="/ras-malai.png" alt="logo" />
    </motion.div>
    <div className='navMenu'>
        <Link to='/'>Home</Link>
        <Link to='/about'>About</Link>
        <Link to='/contact'>Contact</Link>
        <Link to='/cart'><FiShoppingCart/></Link>
        <Link to={isAuthenticated ? '/me' : '/login'}>
            {isAuthenticated ? <FaUser/> : <FiLogIn/>} 
        </Link>
    </div>
    <GiHamburgerMenu onClick={()=>setToggle(!toggle)}/>
    <div className={`navMenuPhone ${toggle ? 'show' : 'hide'}`}>
        <Link to='/'>Home</Link>
        <Link to='/about'>About</Link>
        <Link to='/contact'>Contact</Link>
        <Link to='/cart'><FiShoppingCart/></Link>
        <Link to={isAuthenticated ? '/me' : '/login'}>
            {isAuthenticated ? <FaUser/> : <FiLogIn/>} 
        </Link>
    </div>
  </nav>
}

export default Header